import { Check } from "lucide-react";
import { useState } from "react";

interface OnboardingModalProps {
    onComplete: () => void;
}

const FEATURES = [
    "13-week cash outlook",
    "Weekly margin tracking",
    "AP and AR automation",
];

function OnboardingModal({ onComplete }: OnboardingModalProps) {
    const [isClosing, setIsClosing] = useState(false);

    const handleComplete = () => {
        setIsClosing(true);
        window.setTimeout(() => {
            onComplete();
        }, 200);
    };

    return (
        <div className={`fixed inset-0 z-[2000] flex items-center justify-center bg-black/35 backdrop-blur-sm px-4 transition-opacity duration-200 ${isClosing ? "opacity-0" : "opacity-100"}`}>
            <div className={`flex h-auto w-full max-w-[920px] flex-col overflow-hidden rounded-lg bg-white shadow-2xl transition-all duration-200 sm:h-[400px] sm:flex-row ${isClosing ? "scale-95 translate-y-3" : "scale-100 translate-y-0"}`}>
                <section className="flex min-h-[360px] w-full flex-col justify-between p-8 sm:h-[400px] sm:w-1/2 sm:min-w-0 sm:flex-none sm:p-[60px]">
                    <div className="flex w-full max-w-[340px] flex-col gap-3">
                        <h2 className="font-sans text-[28px] font-semibold leading-[34px] text-[#1F2937]">
                            The weekly finance view for operators
                        </h2>
                        <p className="font-sans text-sm leading-[140%] text-[#1F2937]">
                            Save 20+ hours a week and improve margins by up to 5% by turning banking, accounting, and business data into action.
                        </p>
                        <div className="mt-1 flex flex-col gap-1">
                            {FEATURES.map((feature) => (
                                <div key={feature} className="flex min-h-5 items-center gap-1">
                                    <span className="flex h-4 w-4 shrink-0 items-center justify-center">
                                        <Check className="h-4 w-4 text-[#8385FB]" strokeWidth={1.75} />
                                    </span>
                                    <span className="font-sans text-sm leading-[140%] text-[#1F2937]">
                                        {feature}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={handleComplete}
                        className="mt-8 inline-flex h-[37px] w-[109px] items-center justify-center rounded-lg bg-[#1F2937] px-4 py-2 font-sans text-sm font-medium leading-[150%] text-white transition-colors hover:bg-[#111827]"
                    >
                        Get started
                    </button>
                </section>

                <section className="relative min-h-[280px] w-full bg-[#111827] sm:h-[400px] sm:w-1/2 sm:min-w-0 sm:flex-none">
                    <img
                        src="/images/onboard_images/onboarding-product-preview.png"
                        alt="Finz AI CFO product preview"
                        className="block h-full w-full object-cover"
                    />
                </section>
            </div>
        </div>
    );
}

export default OnboardingModal;
